<div class="flex items-center justify-center min-h-full md:h-auto py-4">
  <div class="rounded-lg w-full md:w-[500px] p-2 md:relative">
    
    <div>
      <h2 class="headline-06 text-[#134F82] mb-2">
        Crea tu nueva contraseña
      </h2>

      <div class="mb-4">
        <p class="text-sm text-gray-600">
          Recuerda que debe tener al menos 8 caracteres, una mayúscula y un carácter especial.
        </p>
      </div>

      <!-- Campo: Nueva contraseña -->
      <mat-form-field appearance="fill" class="w-full custom-input">
        <mat-label>Nueva contraseña</mat-label>
        <input matInput [type]="hide1 ? 'password' : 'text'" [formControl]="nueva" />
        <button mat-icon-button matSuffix (click)="hide1 = !hide1" type="button">
          <mat-icon>{{ hide1 ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="nueva?.hasError('required')">Campo obligatorio</mat-error>
      </mat-form-field>

      <!-- Strength Checklist -->
      <div style="font-size: 13px; margin-bottom: 16px;">
        <div [style.color]="hasMinLength() ? 'green' : 'red'">✔ Mínimo 8 caracteres.</div>
        <div [style.color]="hasNumber() ? 'green' : 'red'">✔ Incluye número</div>
        <div [style.color]="hasUpperCase() ? 'green' : 'red'">✔ Incluye una letra Mayúscula</div>
        <div [style.color]="hasSpecialChar() ? 'green' : 'red'">✔ Incluye un carácter especial ($!%*?&+-_)</div>
      </div>

      <!-- Campo: Confirmar contraseña -->
      <mat-form-field appearance="fill" class="w-full mb-4 custom-input">
        <mat-label>Confirma tu nueva contraseña</mat-label>
        <input matInput [type]="hide2 ? 'password' : 'text'" [formControl]="confirmacion" />
        <button mat-icon-button matSuffix (click)="hide2 = !hide2" type="button">
          <mat-icon>{{ hide2 ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="confirmacion?.hasError('required') && confirmacion?.touched">Campo obligatorio</mat-error>
        <mat-error *ngIf="confirmacion?.hasError('mismatch') && confirmacion?.touched">Las contraseñas no coinciden</mat-error>
      </mat-form-field>

    </div>

    <p *ngIf="errorInesperado" class="text-[#BA1A1A] mx-1 pb-3">
        Ha ocurrido un error. Intenta más tarde.
    </p>

    <div class="mt-6 md:mt-4 mb-6">
      <button class="w-full rounded-full bg-[#0E365A] text-white py-3 text-center" [disabled]="!isFormValid()" (click)="onSubmit()">
        Restablecer contraseña
      </button>
      
    </div>
  </div>
</div>